import axios from "axios";
import cookie from "react-cookies";
import {
  RIMS_COOKIE_STG_CONSTANTS,
  RIMS_SESSION_STG_CONSTANTS,
} from "../constants";
import { useConfigStore } from "../store/config";
import { getApiGateway } from "../common/utils";
import { getResolvedTenantId } from "../common/tenant";

function getURLDomain() {
  const splitByDot = window.location.hostname.split(".");
  const newArray = splitByDot.slice(1);
  const domainName = newArray.join(".");
  return `api.${domainName}`;
}

export const basicUrl = getApiGateway();
let config = {
  baseURL: basicUrl,
  //   timeout: 60 * 1000, // Timeout
};
const service = axios.create(config);
service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    // Do something before request is sent
    const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    const tenantId = getResolvedTenantId(config.url);
    config.headers = {
      "Content-Type": "application/json;charset=utf-8",
      "X-Tenant-Id": tenantId,
      Authorization: `Bearer ${token}`,
      "Accept-Language": languageformat || "",
      "domain-name": getURLDomain(),
      "x-username": cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_NAME)
    };
    for (let key in config.data) {
      if (config.data[key] === "" || config.data[key] === null) {
        delete config.data[key];
      }
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
service.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  (error) => {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default service;



